import { useMemo } from 'react';
import { Trans, useTranslation } from 'react-i18next';
import SectionDetails from '../../_Sections/SectionDetails';
import SectionGallery from '../../_Sections/SectionGallery';
import SectionDropship from '../../_Sections/SectionDropship';
import SectionPairings from '../../_Sections/SectionPairings';
import SectionBranding from '../../_Sections/SectionBranding';
import SectionSizes from '../../_Sections/SectionSizes';
import { useSelector } from 'react-redux';
import WebsiteStore from '../../../WebsiteStore';
import { styled } from '@mui/material';
import { Helmet } from 'react-helmet-async';
import SectionPricing from '../../_Sections/SectionPricing';
import tKey from '../../../Common/Utils/tKey';
import { useAppSelector } from '../../../Common/_hooks/useAppSelector';
import ProductSEO from '../../_Sections/ProductSEO';

const PRODUCT_ID = 20;
const VIEW_PRODUCT_ID = 26;

export default function FlareSkirtPage() {
  const [t] = useTranslation('page/products/flare-skirt');
  const productData = useAppSelector(state => state.get('appData').get('products').get(String(PRODUCT_ID)));
  const locale = useAppSelector(state => state.get('userData').get('prefs').get('lang'))

  if (!productData) return null

  return <div className="centered-page product-page-v4">
    <ProductSEO
      viewProductId={VIEW_PRODUCT_ID}
      title={t('Custom all-over print Flare Skirts | Products')}
      description={t('Design and create your own custom printed Flare Skirt featuring your artwork. ✔ Print-on-demand drop shipping ✔ No minimums ✔ Made in Canada')}
    />
    <SectionDetails
      viewProductId={VIEW_PRODUCT_ID}
      color="#d7d967"
      bgStyle={{
        backgroundPosition: 'bottom right',
        backgroundRepeat: 'no-repeat',
        backgroundSize: '37%',
      }}
      tag={t('The all-over print')}
      title={t('Flare Skirt')}
      text={t('Add a dash of finesse with custom all-over print flared skirts made on-demand in Montreal, Canada. With a high-rise waist, breezy A-line cut, and mid-thigh length, this skirt offers a flattering, kinetic silhouette. Made from ultrasoftLuxeform fabric, each piece features striking, long-wearing prints that energize every outfit. ')}
      createUrl={productData.get('url_slug') + '?option_fabric=performance-knit'}
      img={require('@resources/img/pages/products/flare-skirt/banner-1-' + locale + '.png')}
      alt={t('Picture of Flare Skirt')}
      details={[
        {
          img: require('@resources/img/pages/products/flare-skirt/icon-1.svg?url'),
          alt: t('icon'),
          text: t('Body-hugging straight skirt with high-rise waist and foldover elastic waistband'),
        },
        {
          img: require('@resources/img/pages/products/flare-skirt/icon-2.svg?url'),
          alt: t('icon'),
          text: t('Made from Luxeform performance fabric: combining the power of spandex with lightness and comfort'),
        },
        {
          img: require('@resources/img/pages/products/flare-skirt/icon-3.svg?url'),
          alt: t('icon'),
          text: t('Falls mid-thigh'),
        },
        {
          img: require('@resources/img/pages/products/flare-skirt/icon-4.svg?url'),
          alt: t('icon'),
          text: t('Vibrant, permanent prints won’t fade with use or washing'),
        },
        {
          img: require('@resources/img/pages/products/flare-skirt/icon-5.svg?url'),
          alt: t('icon'),
          text: t('Digitally printed on demand in Montreal, Canada'),
        },
      ]}
    />
    <SectionGallery images={[
      require('@resources/img/pages/products/flare-skirt/gallery_0.jpg'),
      require('@resources/img/pages/products/flare-skirt/gallery_1.jpg'),
      require('@resources/img/pages/products/flare-skirt/gallery_2.jpg'),
      require('@resources/img/pages/products/flare-skirt/gallery_3.jpg'),
      require('@resources/img/pages/products/flare-skirt/gallery_4.jpg'),
    ]} />

    <SectionDropship
      title={<Trans
        t={t}
        i18nKey={tKey('<yellow>Drop ship</yellow> your <br/>flare skirt <pink>on-demand</pink>')}
        components={{
          yellow: <span className="ty" />,
          pink: <span className="tp" />,
        }}
      />}
      text={t('Your brand and following will love Flare skirts! At prices designed for reselling, Flare skirt made on demand meet the needs of sellers who prefer not to stock inventory. Sell them in your eCommerce store and decide your profit margin')}
    />

    <SectionPricing
      productId={PRODUCT_ID}
      options={['performance-knit']}
    />

    <SectionSizes
      chart="bottoms"
      productId={PRODUCT_ID}
      title={t('Flare Skirt Sizing')}
      text={t('All measurements are approximate. Since our products are made by hand, there may be variations in the finished size of our products between orders or even within an order.')}
    />

    <SectionBranding
      hasLabel
      title={t('Brand your Flare Skirt')}
      text={t('Branding enhances your products. Add custom labels, artist cards or stickers to your packages to create a cohesive message and build your brand.')}
    />

    <SectionPairings
      text={t('Pair your Flare Skirt with these great products to create your own unique styles.')}
      productSlugs={['athletic-crop-top', 'classic-pullover-hoodie', 'relaxed-fit-tank-top']}
    />
  </div>
}